<ng-container *ngFor="let eventsBySection of filteredEventsBySection; trackBy: trackByIndex">
    @if (isDisplayBanner(eventsBySection.sectionName) && targetTab?.interstitialBanners?.bannerEnabled) {
        <ng-template *ngTemplateOutlet="VirtualBanner"></ng-template>
    }

    <accordion
        data-crlat="outerAccordion"
        [ngClass]="{ outerAccordionFeatured: isRacingFeatured }"
        [accordionTitle]="eventsBySection.sectionName"
        [isExpanded]="true"
        [card]="true">
        <accordion-body>
            @for (eventEntity of eventsBySection.events; track trackByIndex($index)) {
                <a class="odds-card" data-crlat="oddsCard" [attr.data-eventid]="eventEntity.id" [routerLink]="formEdpUrl(eventEntity)">
                    <div class="odds-content" data-crlat="oddsContent">
                        <div class="odds-left" data-crlat="oddsLeft">
                            @if (sportName === 'horseracing') {
                                <div class="odds-names" data-crlat="horseracing.odds">
                                    <span [textContent]="eventEntity.localTime"></span>
                                    <span [textContent]="eventEntity.name"></span>
                                </div>
                            }
                            @if (sportName === 'greyhound') {
                                <div class="odds-names" data-crlat="greyhound.odds" [textContent]="eventEntity.name"></div>
                            }
                        </div>
                        @if (eventEntity.liveStreamAvailable) {
                            <div class="odds-right" data-crlat="oddsRight">
                                <svg class="odds-icon-stream">
                                    <use xlink:href="#stream"></use>
                                </svg>
                            </div>
                        }
                    </div>
                </a>
            }
        </accordion-body>
    </accordion>
</ng-container>
<ng-template #VirtualBanner>
    <virtual-entry-point-banner [targetTab]="targetTab" [isUnTiedSport]="true" [sportName]="sportName"></virtual-entry-point-banner>
</ng-template>
